var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 192C220.654 192 192 220.652 192 256C192 291.346 220.654 320 256 320S320 291.346 320 256C320 220.652 291.346 192 256 192ZM608 432H418.779C466.158 388.158 496 325.641 496 256C496 123.451 388.549 16 256 16S16 123.451 16 256S123.451 496 256 496H608C616.836 496 624 488.836 624 480V448C624 439.162 616.836 432 608 432ZM256 352C202.98 352 160 309.02 160 256S202.98 160 256 160S352 202.98 352 256S309.02 352 256 352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTape);
export default __webpack_public_path__ + "static/media/tape.d0434f9a6b6b0b9f097a1f362328025d.svg";
export { ForwardRef as ReactComponent };